import { render, staticRenderFns } from "./TamperDrawer.vue?vue&type=template&id=3cd5c2d2&scoped=true&"
import script from "./TamperDrawer.vue?vue&type=script&lang=js&"
export * from "./TamperDrawer.vue?vue&type=script&lang=js&"
import style0 from "./TamperDrawer.vue?vue&type=style&index=0&id=3cd5c2d2&lang=scss&scoped=true&"
import style1 from "./TamperDrawer.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3cd5c2d2",
  null
  
)

export default component.exports